import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaCloudUploadAlt } from "react-icons/fa";
import Sidebar from "../../common/Sidebar";
import axios from "axios";

const ImageUpload = () => {
  const [image, setImage] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [apiResponse, setApiResponse] = useState(null); // Store the uploaded data from the API
  const [showJson, setShowJson] = useState(false); // Toggle to show JSON data

  const formik = useFormik({
    initialValues: {
      path: "",
      image: null,
    },
    validationSchema: Yup.object({
      path: Yup.string().required("Path is required"),
      image: Yup.mixed().required("Image is required"),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("path", values.path);
      formData.append("images", values.image); // The image file

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/image-upload/create`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setApiResponse(response.data); // Store the response data for later display
        alert("Image uploaded successfully!");
      } catch (error) {
        console.error("Error uploading image:", error.response ? error.response.data : error.message);
        alert("Failed to upload image. Check the console for more details.");
      }
    },
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImagePath(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        formik.setFieldValue("image", file); // Set image file in formik
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <Sidebar />
      <div className="card shadow-lg p-4 rounded-4" style={{ maxWidth: "500px", width: "100%" }}>
        <h3 className="text-center fw-bold text-primary">Upload Your Image</h3>

        {/* Form Start */}
        <form onSubmit={formik.handleSubmit}>
          {/* Image path Selection */}
          <div className="mb-3">
            <label className="form-label fw-bold text-secondary">Select path:</label>
            <select
              className={`form-select shadow-sm border-0 ${formik.touched.path && formik.errors.path ? "border-danger" : ""}`}
              value={formik.values.path}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name="path"
            >
              <option value="" disabled>Select a Path</option>
              <option value="original/inspirations">Inspiraton</option>
              <option value="original/styles">Style</option>
              <option value="original/tattoos">Tattoo</option>
            </select>
            {formik.touched.path && formik.errors.path && <div className="text-danger mt-1">{formik.errors.path}</div>}
          </div>

          {/* File Name Display */}
          <div className="mb-3">
            <label className="form-label fw-bold text-secondary">Selected File:</label>
            <input type="text" className="form-control text-center border-0 shadow-sm bg-light" value={imagePath} readOnly />
          </div>

          {/* File Upload Box */}
          <div
            className="mb-3 border rounded-3 p-4 bg-light shadow-sm position-relative d-flex flex-column align-items-center"
            style={{ cursor: "pointer", transition: "0.3s", borderColor: "#007bff" }}
          >
            <input type="file" className="d-none" id="fileInput" onChange={handleImageChange} accept="image/*" />
            <label htmlFor="fileInput" className="d-block w-100 text-center">
              <FaCloudUploadAlt size={70} className="text-primary mb-2" />
              <p className="mt-2 text-muted fw-bold">Click or Drag & Drop to Upload</p>
            </label>
          </div>
          {formik.touched.image && formik.errors.image && <div className="text-danger text-center mt-1">{formik.errors.image}</div>}

          {/* Image Preview */}
          {image && (
            <div className="mt-4 card border-0 shadow-sm rounded-3 p-3">
              <h5 className="text-center fw-bold text-secondary">Preview</h5>
              <div className="d-flex justify-content-center">
                <img src={image} alt="Preview" className="img-fluid rounded-3 shadow" style={{ maxHeight: "250px", border: "4px solid #007bff" }} />
              </div>
            </div>
          )}

          {/* Submit Button */}
          <button type="submit" className="btn btn-primary w-100 mt-3">
            Upload Image
          </button>
        </form>

        {/* Toggle JSON Data */}
        {apiResponse && (
          <div className="mt-4">
            <button
              className="btn btn-secondary w-100"
              onClick={() => setShowJson(!showJson)}
            >
              {showJson ? "Hide JSON Response" : "Show JSON Response"}
            </button>

            {showJson && (
              <pre className="bg-light p-3 mt-3 border rounded" style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                {JSON.stringify(apiResponse, null, 2).split(/(https?:\/\/[^\s]+)/g).map((part, index) =>
                  part.match(/https?:\/\//) ? (
                    <a key={index} href={part.split('"')[0]} target="_blank" rel="noopener noreferrer">
                      {part}
                    </a>
                  ) : (
                    part
                  )
                )}
              </pre>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
